import styled from '@emotion/styled';

import { inputBaseStyles } from '@/components/common/form/controlStyles';

interface InputTextProps {
	readonly isError?: boolean;
}

export const Container = styled.div`
	position: relative;
	width: 100%;
`;

export const ContainerInput = styled.input<InputTextProps>`
	${(props) => inputBaseStyles(props.theme, props.isError)};
`;

export const IconWrapper = styled.div`
	position: absolute;
	right: 1.6rem;
	top: 50%;
	transform: translateY(-50%);
	pointer-events: none;
`;
